









































































// @ is an alias to /src
import Vue from "vue";
import PuzzleGrid from "@/components/PlayArea/PuzzleGrid.vue";
import SendModal from "@/components/PlayArea/SendModal.vue";
import HelpModal from "@/components/PlayArea/HelpModal.vue";
import NotesPanel from "@/components/GameBuilder/NotesPanel.vue";
import { PuzzleService, Tools } from "../services";
import { PuzzleData, Cell, Note } from "../services/vo";
import {
  PuzzleResponse,
  Game,
  VueConstructor,
  CredentialValidationResponse,
} from "vue/types/vue";
import { Route } from "vue-router";

export default (
  Vue as VueConstructor<
    Vue & {
      $refs: {
        game: Game;
      };
    }
  >
).extend({
  name: "home",
  data() {
    return {
      puzzleid: this.$route.params.puzzleid,
      boardData: new Array<PuzzleData>(),
      success: false,
      showMessage: false,
      sendMessage: "",
      sendingPending: false,
      showSolution: false,
      sendModal: false,
      helpModal: false,
      filled: false,
      sendError: "",
      notes: new Array<Note>(),
      showNotes: false,
      loadingPuzzle: false,
      loadingNotes: false,
      getPuzzleError: false,
    };
  },
  created: async function (): Promise<void> {
    await this.getPuzzle();
  },
  components: {
    PuzzleGrid,
    SendModal,
    HelpModal,
    NotesPanel,
  },
  computed: {
    puzzleFound: function (): boolean {
      return !this.getPuzzleError && this.boardData.length > 0;
    },
    puzzleData(): Array<PuzzleData> {
      return this.boardData;
    },
    canView: function (): boolean {
      let canView: boolean = false;
      if (!this.$store.getters.isLoggedIn) return false;
      try {
        if (this.puzzleData[0].canViewSolution()) {
          return (canView = true);
        }
      } catch (error: any) {
        return (canView = false);
      }
      return canView;
    },
    isFilled: function (): boolean {
      return this.filled;
    },
  },
  methods: {
    getPuzzle: async function (): Promise<void> {
      try {
        this.getPuzzleError = false;
        this.boardData = new Array<PuzzleData>();
        let self = this;
        this.loadingPuzzle = true;
        const puzzle: PuzzleData[] = await PuzzleService.getPuzzleById(
          this.puzzleid
        );
        this.boardData = puzzle;
      } catch (error: any) {
        console.log(error);
        this.getPuzzleError = true;
      } finally {
        this.loadingPuzzle = false;
      }
    },
    back: function () {
      if (confirm("Eventuella förändringar går förlorade")) {
        this.$router.push({
          name: "play",
        });
      }
    },
    help: function (): void {
      this.helpModal = true;
    },
    toggleSolution: async function () {
      if (!this.showSolution) {
        const solution = await PuzzleService.getPuzzleSolution(this.puzzleid);
        this.$refs.game.toggleSolution(solution);
        this.showSolution = true;
      } else {
        this.reset();
        this.showSolution = false;
      }
    },
    toggleNotes: async function (): Promise<void> {
      if (!this.showNotes) {
        this.loadingNotes = true;
        if (this.notes.length <= 0) {
          this.notes = new Array<Note>();
          const notes: Note[] = await PuzzleService.getPuzzleNotes(this.puzzleid);
          this.notes = notes;
        }
        this.showNotes = true;
      } else {
        this.showNotes = false;
        //this.notes = new Array<Note>();
      }
      this.loadingNotes = false;
    },
    reset: function (): void {
      this.$refs.game.reset();
    },
    boardFilled: function (isFilled: boolean): void {
      this.filled = isFilled;
    },
    sendDialog: function (): void {
      this.sendModal = true;
    },
    send: async function (submitterName: string): Promise<void> {
      this.sendingPending = true;
      this.sendError = "";
      this.success = false;
      this.showMessage = false;
      try {
        const submitterValidation: CredentialValidationResponse =
          Tools.submitterValidation(submitterName);
        if (submitterValidation.invalid) {
          throw submitterValidation.message;
        }

        const cells: Array<Cell> = this.$refs.game.getAllCells();
        this.sendMessage = "";
        //await this.$refs.game.send();
        let letters = "";

        for (const c of cells) {
          letters += c.getLetter();
        }
        const response: PuzzleResponse = {
          puzzleid: this.boardData[0].getId(),
          letters: letters,
          submitter: submitterName,
        };
        // console.log(response);
        this.closeSend();
        await PuzzleService.submitResponse(response);
        await new Promise<void>((resolve) =>
          setTimeout(() => {
            resolve();
          }, 500)
        );
        this.sendMessage = "Ditt kryss har skickats in!";
        this.success = true;
      } catch (error: any) {
        this.sendError = error;
        this.sendMessage = this.sendError;
        this.success = false;
      } finally {
        this.sendingPending = false;
        if (!this.success) {
          this.sendDialog();
        }
        this.showMessage = true;
      }
    },
    closeSend: function (): void {
      this.sendModal = false;
    },
    closeHelp: function (): void {
      this.helpModal = false;
    },
    closeConfirm: function (): void {
      this.success = false;
      this.showMessage = false;
      this.sendMessage = "";
    },
    gotoResponses: function (): void {
      this.$router.push({
        name: "responses",
        params: { puzzleid: this.puzzleid },
      });
    },
  },
  beforeRouteLeave: function (to, from, next): void {
    this.$store.commit("puzzleCode", "");
    next();
  },
});
